module.exports = __webpack_public_path__ + "img/21_86.cb99de7b.png";